﻿import type {SectionMeasurements} from "../models/section-measurements.model";
import {writable} from "svelte/store";

export const sectionMeasurementsMappedStore = writable<SectionMeasurements[]>([]);